import React from 'react';
import PropTypes from 'prop-types';

import {
  showCondition,
  hasNumberCondition,
  hasGroupCondition,
  hasDateTimeCondition,
  hasTimeCondition,
  hasGenerativeAiTagCondition
} from '../../utils/index';
import GroupCondition from './GroupCondition';
import NumberCondition from './NumberCondition';
import TextCondition from './TextCondition';
import DateTimeCondition from './DateTimeCondition';
import TimeCondition from './TimeCondition';
import GenerativeAiTagCondition from './GenerativeAiTagCondition';

const MessageCondition = ({ name, ...props }) => {
  if (hasDateTimeCondition(name)) {
    return (
      <DateTimeCondition aria-label="date-time-conditional-picker" {...props} />
    );
  }

  if (hasTimeCondition(name)) {
    return <TimeCondition aria-label="time-conditional-picker" {...props} />;
  }

  if (hasGenerativeAiTagCondition(name)) {
    return (
      <GenerativeAiTagCondition
        aria-label="generative-ai-tag-conditional-select"
        {...props}
      />
    );
  }

  if (hasNumberCondition(name)) {
    return <NumberCondition aria-label="number-conditional-input" {...props} />;
  }

  if (hasGroupCondition(name)) {
    return <GroupCondition aria-label="group-conditional-input" {...props} />;
  }

  if (!showCondition(name)) {
    return null;
  }

  return <TextCondition aria-label="text-conditional-input" {...props} />;
};

MessageCondition.propTypes = {
  name: PropTypes.string
};

export default MessageCondition;
